import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Tabs from "./components/Tabs";
import { generateFilter, getWindowSize } from "./BreakdownByEntities.helpers";

import { PbiReport } from "@components/common";
import { REPORT_ID, REPORT_PAGES } from "@constants";
import { useGetAssignedCompanies } from "@api";
import { Box, Card, CardContent, Stack, Typography } from "@components/base";

export type FilterSchema = {
  $schema: string;
  target: {
    table: string;
    column: string;
  };
  operator: string;
  values: (string | number)[];
  filterType: number;
};

export type Tab = {
  title: string;
  path: string;
  pageId: string;
};

const tabs: Tab[] = [
  {
    title: "vsme.hub.dashboard.report.overview",
    path: "overview",
    pageId: "ReportSection26e61161ba67f1b35b4b",
  },
];

interface VsmeBreakdownByEntities {}

const VsmeBreakdownByEntities: FC<VsmeBreakdownByEntities> = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<Tabs["activeTab"]>("overview");
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [filter, setFilter] = useState<FilterSchema>(generateFilter("overview"));
  const { assignedCompanies } = useGetAssignedCompanies();

  useEffect(() => {
    const handleWindowResize = (): void => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  useEffect(() => {
    setFilter(generateFilter(activeTab));
  }, [activeTab]);

  return (
    <Card>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={3}
      >
        <Typography variant="subtitle1">{t("dashboard.vsmebreakdown")}</Typography>
      </Stack>
      <CardContent>
        <Stack pt={0} spacing={3}>
          {assignedCompanies && (
            <Tabs
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              tabs={[
                ...tabs.map((tab) => ({
                  title: t(tab.title),
                  path: tab.path,
                  pageId: tab.pageId,
                })),
                ...assignedCompanies.map((c) => ({
                  title: c.name,
                  path: c.id,
                  pageId: c.id,
                })),
              ]}
            />
          )}
          <Box
            sx={{
              height: windowSize.innerWidth * 0.28,
              overflow: "hidden",
            }}
          >
            <PbiReport
              bg={"default"}
              reportId={REPORT_ID}
              pageId={
                activeTab === "overview"
                  ? REPORT_PAGES.CO2_SUBSIDIARY_OVERVIEW
                  : REPORT_PAGES.CO2_SUBSIDIARY
              }
              height={windowSize.innerWidth * 0.5}
              extraFilters={[filter]}
            />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default VsmeBreakdownByEntities;
